import { createSvgIcon } from '@mui/material';

export const FilledAlertError = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667zm.834 12.5H9.167V12.5h1.667v1.666zm0-3.334H9.167v-5h1.667v5z" fill="#DA6868" />
  </svg>,
  'FilledAlertError',
);
